(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown"] && !window.DesignMode) return;
  try {
    
  let countdownInterval;

  function initializeCountdown() {
    const second = 1000,
      minute = second * 60,
      hour = minute * 60,
      day = hour * 24;

    return {
      updateDisplay: function (targetDateObj) {
        try {
          const now = new Date().getTime();
          const distance = Math.max(0, targetDateObj.getTime() - now);

          const countdownElement = document.querySelector('.sb-countdown');
          const daysElement = document.getElementById('days');
          const hoursElement = document.getElementById('hours');
          const minutesElement = document.getElementById('minutes');
          const secondsElement = document.getElementById('seconds');
          const title1Element = document.getElementById('title-1');
          const title2Element = document.getElementById('title-2');

          // Actualizar títulos
          if (title1Element && title2Element && countdownElement) {
            title1Element.textContent = countdownElement.dataset.titulo1;
            title1Element.style.color = countdownElement.dataset.colorTitulo1;
            title2Element.textContent = countdownElement.dataset.titulo2;
            title2Element.style.color = countdownElement.dataset.colorTitulo2;
          }

          // Si el contador ha llegado a cero
          if (distance === 0) {
            if (countdownElement) {
              countdownElement.style.display = 'none';
            }
            // Limpiar el intervalo
            if (countdownInterval) {
              clearInterval(countdownInterval);
            }
            return;
          }

          if (daysElement && hoursElement && minutesElement && secondsElement) {
            daysElement.innerText = String(Math.floor(distance / day)).padStart(2, '0');
            hoursElement.innerText = String(Math.floor((distance % day) / hour)).padStart(2, '0');
            minutesElement.innerText = String(Math.floor((distance % hour) / minute)).padStart(2, '0');
            secondsElement.innerText = String(Math.floor((distance % minute) / second)).padStart(2, '0');
          }
        } catch (error) {
          console.error('Error en updateDisplay:', error);
        }
      },
    };
  }

  function startCountdown() {
    if (countdownInterval) {
      clearInterval(countdownInterval);
    }

    setTimeout(function () {
      try {
        const countdownElement = document.querySelector('.sb-countdown');

        if (!countdownElement) {
          console.error('Sección countdown no encontrada');
          return;
        }

        const finishYear = parseInt(countdownElement.dataset.finishYear);
        const finishMonth = parseInt(countdownElement.dataset.finishMonth);
        const finishDay = parseInt(countdownElement.dataset.finishDay);
        const finishHours = parseInt(countdownElement.dataset.finishHours) || 0;
        const finishMinutes = parseInt(countdownElement.dataset.finishMinute) || 0;
        const finishSeconds = parseInt(countdownElement.dataset.finishSeconds) || 0;

        if (isNaN(finishYear) || isNaN(finishMonth) || isNaN(finishDay)) {
          console.error('Valores de fecha inválidos');
          return;
        }

        // Crear fecha objetivo con horas, minutos y segundos
        let targetDate = new Date(finishYear, finishMonth - 1, finishDay, finishHours, finishMinutes, finishSeconds);

        // Si la fecha ya pasó, ocultar el contador
        const now = new Date();
        if (targetDate <= now) {
          countdownElement.style.display = 'none';
          return;
        }

        const countdown = initializeCountdown();

        // Actualizar inmediatamente
        countdown.updateDisplay(targetDate);

        // Configurar actualización periódica
        countdownInterval = setInterval(() => {
          countdown.updateDisplay(targetDate);
        }, 1000);
      } catch (error) {
        console.error('Error al iniciar countdown:', error);
      }
    }, 100);
  }

  // Escuchar eventos de Shopify
  document.addEventListener('shopify:section:load', startCountdown);

  // Iniciar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startCountdown);
  } else {
    startCountdown();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('[data-scroll-animation]');

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target); // Para que la animacion ocurra solo una vez
        }
      });
    }, observerOptions);

    sections.forEach((section) => observer.observe(section));

    AOS.init();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('[data-scroll-animation]');

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    sections.forEach((section) => observer.observe(section));

    AOS.init();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quienes-somos"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('[data-scroll-animation]');

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    sections.forEach((section) => observer.observe(section));

    AOS.init();

    const textTeam = document.querySelectorAll('.sb-quienes-somos__content-text');
    const imgTeam = document.querySelectorAll('.sb-quienes-somos__content-image');

    textTeam.forEach((text, i) => {
      text.addEventListener('mouseover', function () {
        if (imgTeam[i]) {
          imgTeam[i].querySelector('.over-img').classList.add('active');
        }
      });

      text.addEventListener('mouseout', function () {
        if (imgTeam[i]) {
          imgTeam[i].querySelector('.over-img').classList.remove('active');
        }
      });
    });

    imgTeam.forEach((img, i) => {
      img.addEventListener('mouseover', function () {
        img.querySelector('.over-img').classList.add('active');
      });

      img.addEventListener('mouseout', function () {
        img.querySelector('.over-img').classList.remove('active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
